import React, { useState } from "react";
import Select, { StylesConfig } from "react-select";


export interface MultiSelectorOption {
  value: string;
  label: string;
  red?: boolean;
}

interface Props {
  options: Array<MultiSelectorOption>;
  defaultValue?: string;
  onChange: (options: Array<MultiSelectorOption>) => void;
}

export default function MultiNodeSelector({
  options,
  onChange,
  defaultValue,
}: Props): React.ReactElement {
  const styles: StylesConfig<MultiSelectorOption, /*isMulti=*/ true> = {
    multiValue: (base, props) => ({
      ...base,
      backgroundColor: props.data.red ? "#FF7D7D" : base.backgroundColor,
    }),
    option: (base) => ({
      ...base,
      cursor: 'pointer',
    }),
    control: (base) => ({
      ...base,
      cursor: 'pointer',
    }),
  };
  const [selectedOptions, setSelectedOptions] = useState<Array<MultiSelectorOption>>(
    options.filter(option => option.value === defaultValue)
  );
  
  return <Select 
    options={options}
    value={selectedOptions.map(selectedOption => ({
      ...selectedOption,
      // When options is updated with different "red" data selectedOptions also need to be updated
      // in order to keep background color of already selected items up to date (which is based on "red" data) 
      red: options.find(item => item.value === selectedOption.value)?.red,
    }))}
    styles={styles}
    isMulti
    theme={theme => ({
      ...theme,
      colors: {
        ...theme.colors,
        primary: "#454545",
        primary25: "#ededed",
      },
    })}

    onChange={options => {
      if (options) {
        setSelectedOptions(options as Array<MultiSelectorOption>);
        onChange(options as Array<MultiSelectorOption>);
      } else {
        setSelectedOptions([]);
        onChange([]);
      }
    }}
  />;
}